import React, { useState, lazy, Suspense, useEffect } from "react";
import axios from "axios";
import "@fontsource/poppins";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import "./App.css";
import Loader from "./components/Loader";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";
import jsonData from "../src/components/PostEvent/ai-branding.json"; // Import the JSON file
const Navbar = lazy(() => import("../src/components/PostEvent/Navbar"));
const Body = lazy(() => import(".././src/components/PostEvent/Body"));
const Footer = lazy(() => import("./components/Footer"));
const Video = lazy(() => import("./components/Video/Video.js"));
const EventMemories = lazy(() =>
  import("../src/components/PostEvent/EventMemories")
);
const EventMemoriesMobile = lazy(() =>
  import(".././src/components/PostEvent/EventMemoriesMobile.js")
);
const PreMemories = lazy(() =>
  import("../src/components/PostEvent/PreMemories")
);
const PreMemoriesMobile = lazy(() =>
  import(".././src/components/PostEvent/PreMemoriesMobile.js")
);
const Experience = lazy(() =>
  import(".././src/components/PostEvent/Experience.js")
);
const DeskExperience = lazy(() =>
  import("../src/components/PostEvent/DeskExperience.js")
);
const SocialMedia = lazy(() =>
  import(".././src/components/PostEvent/SocialMedia.js")
);
const SocialMediaDesktop = lazy(() =>
  import(".././src/components/PostEvent/SocialMediaDesktop.js")
);
const Thankyou = lazy(() =>
  import(".././src/components/PostEvent/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import("../src/components/PostEvent/SubscribeForEventNotifications.js")
);

function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const appVersion = appversion.version;
  const imgCDNURL = process.env.REACT_APP_POSTMANIA_CDN_URL;
  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
        //console.log(response);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <div className="bodyContainer">
        {links ? (
          <>
            <img
              src={imgCDNURL + "topleftorangeshadow.png"}
              className="flower2 img-fluid"
              alt="Flower"
            />
            <img src={imgCDNURL + "upperdotted.png"} className="dot1" />
            <Suspense fallback={<div />}>
              <Navbar />
            </Suspense>
            <Suspense fallback={<div />}>
              <Body
                handleVideo={handleVideo}
                videoToggle={videoToggle}
                links={links}
              />
            </Suspense>
            <MediaQuery maxWidth={992}>
              <Suspense fallback={<div />}>
                <Experience
                  handleVideo={handleVideo}
                  videoToggle={videoToggle}
                  links={links}
                />
              </Suspense>
            </MediaQuery>
            <MediaQuery minWidth={992}>
              <Suspense fallback={<div />}>
                <DeskExperience
                  handleVideo={handleVideo}
                  videoToggle={videoToggle}
                  links={links}
                />
              </Suspense>
            </MediaQuery>
            <MediaQuery minWidth={992}>
              <Suspense fallback={<div />}>
                <EventMemories links={links} />
              </Suspense>
            </MediaQuery>
            <MediaQuery maxWidth={992}>
              <Suspense fallback={<div />}>
                <EventMemoriesMobile links={links} />
              </Suspense>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <Suspense fallback={<div />}>
                <SocialMedia links={links} />
              </Suspense>
            </MediaQuery>
            <MediaQuery minWidth={992}>
              <Suspense fallback={<div />}>
                <SocialMediaDesktop links={links} />
              </Suspense>
            </MediaQuery>
            <Suspense fallback={<div />}>
              <Thankyou links={links} />
            </Suspense>
            <Suspense fallback={<div />}>
              <SubscribeForEventNotifications />
            </Suspense>
            <MediaQuery minWidth={992}>
              <Suspense fallback={<div />}>
                <PreMemories />
              </Suspense>
            </MediaQuery>
            <MediaQuery maxWidth={992}>
              <Suspense fallback={<div />}>
                <PreMemoriesMobile />
              </Suspense>
            </MediaQuery>
            <Suspense fallback={<div />}>
              <Footer />
            </Suspense>
            <CookieSetting 
              privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
              configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
              analytics={process.env.REACT_APP_ANALYTICS_PATH}
            />
            <Suspense fallback={<Loader />}>
              {played && (
                <Video handleVideo={handleVideo} videoToggle={videoToggle} />
              )}
            </Suspense>
          </>
        ) : null}
      </div>
    </CacheBuster>
  );
}

export default App;
